import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-diary-home",
  templateUrl: "./diary-home.component.html",
  styleUrls: ["./diary-home.component.scss"],
  imports: [RouterOutlet]
})
export class DiaryHomeComponent {}
